<template>
  <table class="simple-table">
    <thead class="simple-table--head">
      <th
        v-for="column in columns"
        :key="`th-${column.value}`"
        class="simple-table--columns"
      >
        <slot :column="column" :name="`${column.value}`">
          {{ column.text }}
        </slot>
      </th>
    </thead>
    <tbody v-if="rows.length" class="simple-table--body">
      <tr
        v-for="(row, index) in rows"
        :key="`tr-row-${index}`"
        class="simple-table--row"
        :class="{
          'simple-table--hightlight': highlightFirstRow && index === 0
        }"
      >
        <slot v-for="c in columns" :name="`row-${c.value}`" :rowItem="row">
          <td
            class="simple-table--cell"
            :key="`td-${row[c.value]}-${c.text}-body`"
          >
            <!-- verifica se o dado está vazio -->
            <span v-if="!row[c.value] && +row[c.value] !== 0">-</span>
            <!-- verifica se o dado é número e se deve ser formatado -->
            <span
              v-else-if="numFormat && !ignoreNumFormatCols.includes(c.value)"
            >
              {{ row[c.value] | numFormat(numberMask) }}
            </span>
            <span v-else>
              {{ row[c.value] }}
            </span>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>

<script>
/**
 * Componente de uma tabela simples que recebe por prop as colunas e linhas
 */
export default {
  name: 'SimpleTable',
  props: {
    /**
     * Um array de objetos com os nomes e ids das colunas da tabela
     * Ex:
     * [
        { id: 1, text: 'Quartos', value: 'quarto'  },
        { id: 2, text: 'Diferencial', value: 'diferencial' },
        { id: 3, text: '1 Pax', value: 'pax1' }
      ]
     */
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * Um array com os items que irão popular as linhas da tabela
     * [
        {
          quarto: 'Apto Luxo | Quarto básico',
          diferencial: 0,
          pax1: 0,
        }
      ]
     */
    rows: {
      type: Array,
      default: () => []
    },
    /**
     * se o campo terá o filtro numFormat
     */
    numFormat: {
      type: Boolean,
      default: false
    },
    /** Máscara de formatação de números */
    numberMask: {
      type: String,
      default: '0.00'
    },
    /**
     * array com as colunas que não terão filtro numFormat
     */
    ignoreNumFormatCols: {
      type: Array,
      default: () => []
    },
    /**
     * se a primeira linha será destacada
     */
    highlightFirstRow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
$bg-row: $gray-lightest;
$border-table: $gray-border;
$main-color: $gray-darkest;
$color-head: $white;

.simple-table {
  width: 100%;
  border-collapse: collapse;
  font-size: font-size('size-small');
  color: $main-color;
  text-align: end;

  &--head {
    font-weight: font-weight('weight-medium');
    border-bottom: 1px solid $border-table;
    padding-bottom: 0.5em;
    background-color: $color-head;
    color: $gray-darkest;
  }

  &--body {
    background-color: transparent;
  }

  &--cell {
    padding: 0.8em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
    color: $gray-table;
  }

  &--row {
    td {
      padding-bottom: 11px;

      &:last-child {
        padding-right: 50px;
      }
      &:first-child {
        padding-left: 50px;
      }
    }

    &:last-child {
      td {
        padding-bottom: 23px;
      }
    }
  }

  &--column {
    width: 100%;
    padding: 0em 0.8em;
    display: flex;
    justify-content: flex-end;
  }

  &--columns {
    padding: 0.8em;
    &:first-child {
      padding-left: 50px;
      padding-bottom: 5px;
      text-align: left;
    }

    &:last-child {
      padding-right: 50px;
    }
  }

  &--hightlight {
    font-weight: font-weight('weight-semi-bold');
  }
}
</style>
